import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const Experiment = (props) => {
    const { children } = props;
    return _jsx(_Fragment, { children: children }, void 0);
};
export default Experiment;
//# sourceMappingURL=Experiment.js.map